export const USER_INVESTMENT_START = "USER_INVESTMENT_START";
export const GET_USER_INVESTMENT = "GET_USER_INVESTMENT";
export const GET_USER_INVESTMENTS_SUCCESS = "GET_USER_INVESTMENT_SUCCESS";
export const GET_USER_INVESTMENTS_FAIL = "GET_USER_INVESTMENT_FAIL";
